import { defineMessages } from "react-intl";

const messages = defineMessages({
  robertetFr: {
    id: "modules.User.StoreViewSelector.robertetFr",
    defaultMessage: "Europe & Middle East (FR)",
  },
  us: {
    id: "modules.User.StoreViewSelector.us",
    defaultMessage: "US & Canada (EN)",
  },
  robertetEn: {
    id: "modules.User.StoreViewSelector.robertetEn",
    defaultMessage: "Europe & Middle East (EN)",
  },
});

const getShopName = (id, intl) => {
  if (id === "robertet_fr") {
    return intl.formatMessage(messages.robertetFr);
  }
  if (id === "us_en") {
    return intl.formatMessage(messages.us);
  }
  if (id === "robertet_en") {
    return intl.formatMessage(messages.robertetEn);
  }

  return id.substring(id.length - 2);
};

export default getShopName;
